import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { ModalHeader, FloraTypography, ModalBody, Flex, FloraButton } from '@grupoboticario/flora-react'
import { CheckSingleIcon } from '@grupoboticario/flora-react-icons'

import ActionModal from '@/components/Modal/ActionModal'
import { CopyClipboard } from '@/icons/CopyClipboard'

import * as S from './ModalPublishedCampaign.styles'

export const ModalPublishedCampaign = ({
  openPublishCampaignModal,
  setOpenPublishCampaignModal,
  campaignIdVoucher
}) => {
  const [isCopied, setIsCopied] = useState(false)
  const navigate = useNavigate()

  const handleClipboard = () => {
    navigator.clipboard.writeText(campaignIdVoucher)
    setIsCopied(true)
    setTimeout(() => setIsCopied(false), 2000)
  }

  const handleClose = () => {
    setOpenPublishCampaignModal(false)
    navigate('/acceleration')
  }

  return (
    <ActionModal
      css={S.modalWrapperCss}
      onOpenChange={setOpenPublishCampaignModal}
      open={Boolean(openPublishCampaignModal)}
      size="small"
    >
      <ModalHeader>
        <FloraTypography as="h5" fontSize="title">
          Acelerador publicado
        </FloraTypography>
      </ModalHeader>
      <ModalBody>
        <Flex direction="column" gap="$6">
          <Flex direction="column" gap="$3">
            <FloraTypography fontSize="bodyLargeStandard" css={S.centeredTextCss}>
              Número de audiência:
            </FloraTypography>

            {isCopied ? (
              <Flex align="center" gap="$3" justify="center">
                <FloraTypography fontSize="bodyLargeStandard" css={S.centeredCss}>
                  Copiado!
                </FloraTypography>
                <CheckSingleIcon size={18} />
              </Flex>
            ) : (
              <Flex align="center" css={S.clickableRowCss} gap="$3" justify="center" onClick={handleClipboard}>
                <FloraTypography fontSize="bodyLargeStandard" css={S.emphasizedTextCss} fontWeight="bold">
                  {campaignIdVoucher}
                </FloraTypography>
                <CopyClipboard />
              </Flex>
            )}
          </Flex>
          <FloraButton isFull onClick={handleClose} hierarchy="secondary">
            Fechar
          </FloraButton>
        </Flex>
      </ModalBody>
    </ActionModal>
  )
}
